import React, { useState } from "react";
import "./Products.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PackagesScroller from "./Packages/PackagesScroller";
import BundlesScroller from "./Bundles/BundlesScroller";
import ProductScroller from "./Products/ProductScroller";
import "./Products/MyProductsHeader.css";

// The title's hint: what a click does on each tab. A product goes into the
// fulfilment order (and its packages into Dimensions & Weight); a bundle or a
// package only fills package rows.
const HINTS = {
  Products: "click one to fulfil it from your location",
  Bundles: "click one to add its packages below",
  Packages: "click one to add its size and weight below",
};

export default function Products(props) {
  const {
    Plist,
    SetPlist,
    StepCheck,
    SetStepCheck,
    SelectedProducts,
    setSelectedProducts,
    bundleRefresh,
    setbundleRefresh,
    packageRefresh,
    setpackageRefresh,
  } = props;

  const [isExpanded, setIsExpanded] = useState(true);
  const [view, setView] = useState("List");

  const handleExpandToggle = () => {
    setIsExpanded((prevExpanded) => !prevExpanded);
  };

  return (
    <>
      <div className="card bg-ui-surface shadow wapper_like_shopify productDetailsCustom__main_package_wrap">
        <div className="card-header myprod__head">
          {/* Titled like the Shipment type and Fulfilment location cards; the
              hint replaces the old info icon ("Saved Products , Bundles &
              Packages"). */}
          <div className="myprod__title">
            Saved items{" "}
            {HINTS[StepCheck["Products"]] && (
              <span className="myprod__hint">{HINTS[StepCheck["Products"]]}</span>
            )}
          </div>
        </div>
        {/* <div className="expand_btn" onClick={handleExpandToggle}>
        {isExpanded ? (
          <>
            <Tooltip title="Collapse">
              <IconButton>
                <MdOutlineKeyboardArrowUp size={15} />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title="Expand">
              <IconButton className="fullfilment__form_expand_btn">
                <MdOutlineKeyboardArrowDown size={15} />
              </IconButton>
            </Tooltip>
          </>
        )}
      </div> */}
        <div className="card-body product_scroll_my_product  myprod_card_body productDetailsCustom__main_package_bundles">
          {StepCheck["Products"] === "Packages" && (
            <Row
              className={`mb-1 product__scrollbar_list ${
                isExpanded ? "expanded" : "collapse__row"
              }`}
            >
              <Col md={12}>
                <PackagesScroller
                  Plist={Plist}
                  SetPlist={SetPlist}
                  StepCheck={StepCheck}
                  SetStepCheck={SetStepCheck}
                  packageRefresh={packageRefresh}
                  setpackageRefresh={setpackageRefresh}
                  view={view}
                  setView={setView}
                />
              </Col>
            </Row>
          )}
          {StepCheck["Products"] === "Bundles" && (
            <Row
              className={`mb-1 product__scrollbar_list ${
                isExpanded ? "expanded" : "collapse__row"
              }`}
            >
              <Col md={12}>
                <BundlesScroller
                  Plist={Plist}
                  SetPlist={SetPlist}
                  StepCheck={StepCheck}
                  SetStepCheck={SetStepCheck}
                  bundleRefresh={bundleRefresh}
                  setbundleRefresh={setbundleRefresh}
                  view={view}
                  setView={setView}
                />
              </Col>
            </Row>
          )}
          {StepCheck["Products"] === "Products" && (
            <Row
              className={`mb-1 product__scrollbar_list ${
                isExpanded ? "expanded" : "collapse__row"
              }`}
            >
              <Col md={12}>
                <ProductScroller
                  Plist={Plist}
                  SetPlist={SetPlist}
                  StepCheck={StepCheck}
                  SetStepCheck={SetStepCheck}
                  SelectedProducts={SelectedProducts}
                  setSelectedProducts={setSelectedProducts}
                  view={view}
                  setView={setView}
                />
              </Col>
            </Row>
          )}
        </div>
      </div>
    </>
  );
}
